import { render, staticRenderFns } from "./IntegrationsList.vue?vue&type=template&id=b1388bb8&scoped=true&"
import script from "./IntegrationsList.vue?vue&type=script&lang=js&"
export * from "./IntegrationsList.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsList.vue?vue&type=style&index=0&id=b1388bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1388bb8",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsList.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsList.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports